 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"colors-colors-module":"colors-colors-module","common":"common","article-groups-article-groups-module":"article-groups-article-groups-module","follow-detail-follow-detail-module":"follow-detail-follow-detail-module","modules-hierarchy-country-hierarchy-country-module":"modules-hierarchy-country-hierarchy-country-module","showroom-2-0-showroom-2-0-module":"showroom-2-0-showroom-2-0-module","showroom-food-showroom-food-module":"showroom-food-showroom-food-module","country-overview-country-overview-module":"country-overview-country-overview-module","default~file-upload-file-upload-module~follow-settings-follow-settings-module":"default~file-upload-file-upload-module~follow-settings-follow-settings-module","file-upload-file-upload-module":"file-upload-file-upload-module","default~follow-discrepancies-follow-discrepancies-module~follow-settings-follow-settings-module~modu~f64173ff":"default~follow-discrepancies-follow-discrepancies-module~follow-settings-follow-settings-module~modu~f64173ff","modules-covers-covers-module":"modules-covers-covers-module","modules-packaging-packaging-module":"modules-packaging-packaging-module","default~follow-discrepancies-follow-discrepancies-module~modules-follows-list-follows-list-module~pr~ad8c063b":"default~follow-discrepancies-follow-discrepancies-module~modules-follows-list-follows-list-module~pr~ad8c063b","default~follow-discrepancies-follow-discrepancies-module~proformaUI-proformaUI-module":"default~follow-discrepancies-follow-discrepancies-module~proformaUI-proformaUI-module","follow-discrepancies-follow-discrepancies-module":"follow-discrepancies-follow-discrepancies-module","default~follow-settings-follow-settings-module~modules-retroplanning-retroplanning-module":"default~follow-settings-follow-settings-module~modules-retroplanning-retroplanning-module","default~follow-settings-follow-settings-module~modules-alarms-alarms-module":"default~follow-settings-follow-settings-module~modules-alarms-alarms-module","default~follow-settings-follow-settings-module~modules-hangers-hangers-module":"default~follow-settings-follow-settings-module~modules-hangers-hangers-module","follow-settings-follow-settings-module":"follow-settings-follow-settings-module","modules-follows-list-follows-list-module":"modules-follows-list-follows-list-module","modules-alarms-alarms-module":"modules-alarms-alarms-module","modules-hangers-hangers-module":"modules-hangers-hangers-module","modules-retroplanning-retroplanning-module":"modules-retroplanning-retroplanning-module","default~modules-providers-management-providers-management-module~modules-providers-providers-module~~47ecf099":"default~modules-providers-management-providers-management-module~modules-providers-providers-module~~47ecf099","modules-providers-management-providers-management-module":"modules-providers-management-providers-management-module","modules-supplier-supplier-module":"modules-supplier-supplier-module","follow-approval-follow-approval-module":"follow-approval-follow-approval-module","import-products-import-products-module":"import-products-import-products-module","kanban-kanban-module":"kanban-kanban-module","modules-adfs-adfs-module":"modules-adfs-adfs-module","modules-all-follows-all-follows-module":"modules-all-follows-all-follows-module","modules-brands-brands-module":"modules-brands-brands-module","modules-brief-brief-module":"modules-brief-brief-module","modules-color-businesses-color-businesses-module":"modules-color-businesses-color-businesses-module","modules-color-hierarchy-color-hierarchy-module":"modules-color-hierarchy-color-hierarchy-module","modules-destination-destination-module":"modules-destination-destination-module","modules-global-ocm-global-ocm-module":"modules-global-ocm-global-ocm-module","modules-hierarchy-food-hierarchy-food-module":"modules-hierarchy-food-hierarchy-food-module","modules-hierarchy-hierarchy-module":"modules-hierarchy-hierarchy-module","modules-hierarchy-master-hierarchy-master-module":"modules-hierarchy-master-hierarchy-master-module","modules-login-login-module":"modules-login-login-module","modules-logs-logs-module":"modules-logs-logs-module","modules-new-follow-new-follow-module":"modules-new-follow-new-follow-module","modules-notifications-notifications-module":"modules-notifications-notifications-module","modules-packaging-manager-packaging-manager-module":"modules-packaging-manager-packaging-manager-module","modules-ports-ports-module":"modules-ports-ports-module","modules-profile-profile-module":"modules-profile-profile-module","modules-profiles-profiles-module":"modules-profiles-profiles-module","modules-shipping-times-shipping-times-module":"modules-shipping-times-shipping-times-module","modules-supplier-managements-supplier-managements-module":"modules-supplier-managements-supplier-managements-module","modules-sustainability-sustainability-module":"modules-sustainability-sustainability-module","modules-unit-business-unit-business-module":"modules-unit-business-unit-business-module","modules-users-users-module":"modules-users-users-module","new-product-new-product-module":"new-product-new-product-module","overview-overview-module":"overview-overview-module","trash-trash-module":"trash-trash-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
